// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".split-left[data-v-11283c8f]{width:100%}@media (min-width:900px){.split-left[data-v-11283c8f]{width:55%}}.split-right[data-v-11283c8f]{width:100%}.split-right.restrict-height[data-v-11283c8f]{height:100%;max-height:20rem;min-height:12rem}@media (min-width:900px){.split-right.restrict-height[data-v-11283c8f]{max-height:100%;min-height:0}}@media (min-width:900px){.split-right[data-v-11283c8f]{width:45%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
